import { Box, Typography } from "@mui/material";

import { EllipsisText } from "@/common/components/ellipsis-text/EllipsisText";
import { useTranslation } from "@/translations";

interface Props {
  label: string;
  value?: React.ReactNode;
  indicator?: React.ReactNode;
}

export function ClientStatusWidgetRow({ label, value, indicator }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <Box display="flex" alignItems="center" pl={1} py={0.75}>
        <Typography variant="body2">{label}</Typography>
      </Box>
      <Box display="flex" gap={2} alignItems="center" pr={1} py={0.75} minWidth={0}>
        {typeof value === "string" || value === undefined ? (
          <EllipsisText value={value ?? t("common.notAvailable")} variant="body2" />
        ) : (
          <Typography variant="body2">{value}</Typography>
        )}
        {indicator}
      </Box>
    </>
  );
}
